export const AI_AGENT_KNOWLEDGE_DOCUMENT_MAX_BYTES = 10_000_000;
// Provider and throughput are optional additions that schema-v2 releases can safely ignore.
// Keep this rollback-compatible marker until a genuinely incompatible configuration shape ships.
export const AI_TENANT_CONFIGURATION_SCHEMA_VERSION = 2;
export const DEFAULT_AI_GUARDRAIL_SETTINGS = {
    blockedInputPhrases: [],
    blockedOutputPhrases: [],
    lowConfidenceAction: 'clarify',
    maximumClarificationAttempts: 1,
    maximumResponseCharacters: 5_000,
    minimumRelevanceScore: 0.3,
    outputFailureAction: 'handoff',
    restrictedInputAction: 'handoff',
};
export function aiKnowledgeMinimumRelevanceScore(strictness) {
    return { relaxed: 0.1, standard: 0.3, strict: 0.5 }[strictness];
}
export const webhookEventTypes = [
    'conversation.created',
    'conversation.assigned',
    'conversation.updated',
    'message.created',
];
//# sourceMappingURL=contracts.js.map